// hook para consultar permissões de um usuário
export function usePermissao() {

  // pega a lista salva no localStorage
  const permissoes = JSON.parse(localStorage.getItem("permissoes")) || [];

  /****/
  function acessoPermissao(tela, acao) {

    if (!tela || !acao) return false;

    const regra = permissoes.find(
      (p) => p.tela === tela
    );

    if (!regra) return false;

    return regra[acao] === 1;
  }

  /****/
  function permissoesDaTela(tela) {

    return permissoes.find(
      (p) => p.tela === tela
    ) || null;
  }

  return {
    acessoPermissao,
    permissoesDaTela,
    permissoes
  };

}